let envval = '_AUTH';
let storkey = {
  from: 'from', //渠道
  token: 'token',
  rolename: 'rolename',
  nickname: 'nickname',
  choicesys: 'choicesys',
  uuid: 'uuid',
  userinfo: 'userinfo',
  activity: 'activity'
};
//set storage
function setStorage(key, value) {
  localStorage.setItem(storkey[key] + envval, JSON.stringify(value));
}
//get storage
function getStorage(key) {
  let val = localStorage.getItem(storkey[key] + envval);
  return JSON.parse(val);
}

function removeStorage(key) {
  localStorage.removeItem(storkey[key] + envval);
}

function clearStorage() {
  localStorage.clear();
}

export default {
  setStorage,
  getStorage,
  removeStorage,
  clearStorage
};
